import { createContext, useContext, useEffect } from "react";

/**
 * Dark-only theme ("noc"). The light ("dzień") theme has been removed —
 * the app now always renders in the dark palette.
 */
const ThemeContext = createContext({ theme: "dark", resolved: "dark" });

function applyDark() {
  if (typeof document === "undefined") return;
  const html = document.documentElement;
  html.classList.add("dark");
  html.classList.remove("light");
  html.setAttribute("data-theme", "dark");
}

export function ThemeProvider({ children }) {
  useEffect(() => {
    applyDark();
  }, []);
  return (
    <ThemeContext.Provider value={{ theme: "dark", resolved: "dark" }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
